import "./TextInputField.scss";

import { FunctionComponent } from "react";
import { TextField } from "@mui/material";
import { TextInputFieldProps } from "./ITextInputFieldProps";

const TextInputField: FunctionComponent<TextInputFieldProps  & { inputRef?: React.Ref<HTMLInputElement> }> = (props) => {
  const {
    id,
    name,
    placeholder,
    variant,
    label,
    color,
    required,
    className,
    sx,
    value,
    defaultValue,
    error,
    disabled,
    readOnly,
    fullWidth,
    type,
    inputClassName,
    helperText,
    InputProps,
    shrink,
    inputLableStyle,
    size = "medium",
    labelSize,
    onChange,
    onBlur,
    onFocus,
    onClick,
    tabIndex,
    inputRef,
  } = props;
  return (
    <TextField
      id={id}
      tabIndex={tabIndex}
      name={name}
      variant={variant}
      label={label}
      color={color}
      placeholder={placeholder}
      autoComplete="on"
      required={required}
      fullWidth={fullWidth}
      className={`GlobalInputStyle ${className}`}
      sx={sx}
      value={value}
      defaultValue={defaultValue}
      error={error}
      helperText={helperText}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
      disabled={disabled}
      type={type ?? "text"}
      size={size}
      InputProps={{
        ...InputProps,
        readOnly: readOnly,
        className: `GlobalInputPropsStyle ${inputClassName}`,
      }}
      InputLabelProps={{
        shrink: shrink,
        size: labelSize,
        className: `GlobalInputLableStyle ${inputLableStyle}`,
      }}
        inputRef={inputRef}
    />
  );
};

export default TextInputField;
